export enum UserRole {
    MEMBER = 0,
    BUSINESS = 1,
    ADMIN = 2,
  }